import React from 'react'
import T from 'prop-types'
import { Form, Field } from 'react-final-form'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Button, FormControlLabel } from '@material-ui/core'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import * as ROUTE from 'constants/appRouting'
import { Checkbox } from 'components/common/FormInputs'
import messages from './translate'

function LoginForm({ intl: { formatMessage }, onSubmit }) {
  const initialValues = {
    rememberMe: true,
  }

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Field
            name="email"
            type="email"
            placeholder={formatMessage(messages.emailOrUsername)}
            className="form-control-lg"
            component={Input}
            disabled={submitting}
            disableLabelMove
            validate={getValidator([VALIDATOR_IS_EMPTY])}
          />
          <Field
            name="password"
            placeholder={formatMessage(messages.password)}
            className="form-control-lg"
            render={props => <Input type="password" {...props} />}
            disabled={submitting}
            disableLabelMove
            validate={getValidator(VALIDATOR_IS_EMPTY)}
          />
          <div className="form-group login-form-group">
            <FormControlLabel
              label={formatMessage(messages.remember_me)}
              labelPlacement="end"
              control={
                <Field
                  name="rememberMe"
                  component={Checkbox}
                  type="checkbox"
                  color="primary"
                />
              }
            />
            <Link
              to={ROUTE.FORGOT_PASSWORD}
              className="login-text forgot-password">
              <FormattedMessage {...messages.forgot_password} />
            </Link>
          </div>
          <div className="form-group">
            <Button
              href={null}
              type="submit"
              color="primary"
              size="large"
              variant="contained"
              className="login-form-submit-button"
              onClick={handleSubmit}
              disabled={submitting}
              fullWidth>
              {formatMessage(messages.login)}
            </Button>
          </div>
        </form>
      )}
    />
  )
}

LoginForm.propTypes = {
  onSubmit: T.func.isRequired,
  intl: T.shape({
    formatMessage: T.func,
  }).isRequired,
}

export default injectIntl(LoginForm)
